
import "./bAdminTable/bAdminTable.sass";
import "./bDialogCard/bDialogCard.sass";
import "./bSideBar/bSideBar.sass";
import "./pAdminRates/pAdminRates.sass";
import "./pClient/pClient.sass";
import "./pClientGroups/pClientGroups.sass";
import "./pClients/pClients.sass";
import "./pCountries/pCountries.sass";
import "./pCountry/pCountry.sass";
import "./bProjects/bProjects.sass";
import "./pGroups/pGroups.sass";
import "./pInterrupts/pInterrupts.sass";
import "./pProcessGroupConfigurations/pProcessGroupConfigurations.sass";
import "./pServiceLines/pServiceLines.sass";
import "./pTeam/pTeam.sass";
import "./pUser/pUser.sass";
import "./pUsers/pUsers.sass";
import "./pApi/pApi.sass";
import "./pLicenseAgreements/pLicenseAgreements.sass";
import "./bDialogCard/fields/bSelectMdpId/bSelectMdpId.sass";
import "./pReports/pReports.sass";



import { bSideBarDirective }                    from './bSideBar/bSideBar.directive';
import { bDialogCardDirective }                 from './bDialogCard/bDialogCard.directive';
import { pCountriesDirective }                  from './pCountries/pCountries.directive';
import { pInterruptsDirective }                 from './pInterrupts/pInterrupts.directive';
import { bAdminTableDirective }                 from './bAdminTable/bAdminTable.directive';
import { pGroupsDirective }                     from './pGroups/pGroups.directive';
import { pCountryDirective }                    from './pCountry/pCountry.directive';
import { bProjectsDirective }                   from './bProjects/bProjects.directive';
import { bShareModalDirective }                 from '../360view/p360ViewManager/bShareModal/bShareModal.directive';
import { pProcessGroupConfigurationsDirective } from './pProcessGroupConfigurations/pProcessGroupConfigurations.directive';
import { pUsersDirective }                      from './pUsers/pUsers.directive';
import { pUserDirective }                       from './pUser/pUser.directive';
import { pClientsDirective }                    from './pClients/pClients.directive';
import { pClientGroupsDirective }               from './pClientGroups/pClientGroups.directive';
import { pClientDirective }                     from './pClient/pClient.directive';
import { pServiceLinesDirective }               from './pServiceLines/pServiceLines.directive';
import { pTeamDirective }                       from './pTeam/pTeam.directive';
import { pAdminRatesDirective }                 from './pAdminRates/pAdminRates.directive';
import { pFeatureFlagsDirective }               from './pFeatureFlags/pFeatureFlags.directive';
import { pApiDirective }                        from './pApi/pApi.directive';
import { pLicenseAgreementsDirective }          from './pLicenseAgreements/pLicenseAgreements.directive';
import { bSelectMdpIdDirective }                from './bDialogCard/fields/bSelectMdpId/bSelectMdpId.directive';
import { pReportsDirective }                    from "./pReports/pReports.directive";

import { AdminService }                         from './Admin.service';

export default angular.module(
  'frontend.admin',
  ["frontend.api", "frontend.auth", "frontend.theme", "frontend.adminCountryTables"]
)
  .directive('bSelectMdpId', bSelectMdpIdDirective)
  .directive('bSideBar', bSideBarDirective)
  .directive('bDialogCard', bDialogCardDirective)
  .directive('pCountries', pCountriesDirective)
  .directive('pInterrupts', pInterruptsDirective)
  .directive('bAdminTable', bAdminTableDirective)
  .directive('pGroups', pGroupsDirective)
  .directive('pCountry', pCountryDirective)
  .directive('bProjects', bProjectsDirective)
  .directive('bShareModal', bShareModalDirective)
  .directive('pProcessGroupConfigurations', pProcessGroupConfigurationsDirective)
  .directive('pUsers', pUsersDirective)
  .directive('pUser', pUserDirective)
  .directive('pClients', pClientsDirective)
  .directive('pClientGroups', pClientGroupsDirective)
  .directive('pClient', pClientDirective)
  .directive('pServiceLines', pServiceLinesDirective)
  .directive('pTeam', pTeamDirective)
  .directive('pAdminRates', pAdminRatesDirective)
  .directive('pFeatureFlags', pFeatureFlagsDirective)
  .directive('pApi', pApiDirective)
  .directive('pLicenseAgreements', pLicenseAgreementsDirective)
  .directive('pReports', pReportsDirective)
  .service('Admin', AdminService);
